<template>
  <div class="help-center">
    <el-tabs v-model="tab">
      <el-tab-pane label="业务流程" name="flow">
        <div class="biz-flow">
          <div class="intro">
            <h2>系统业务流程</h2>
            <p>华锐智造云按制造执行来用：先备主数据，再开工单和工序，车间报工确认后扣料入库，仓库和设备维保并行。详细步骤见「操作手册」页签。首页「业务流程引导」可按权限直接进入对应菜单。</p>
          </div>

          <section class="flow-block">
            <div class="flow-title">一、主流程</div>
            <div class="flow-row">
              <div class="node primary">
                <div class="n-step">1</div>
                <div class="n-name">主数据</div>
                <div class="n-desc">产品 · 工序 · 工艺<br/>车间 · 产线 · 仓库 · 员工</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">2</div>
                <div class="n-name">计划与工单</div>
                <div class="n-desc">主订单（可选）<br/>生产工单受理开工<br/>工序任务开工</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">3</div>
                <div class="n-name">车间执行</div>
                <div class="n-desc">已开工任务报工<br/>确认后扣料、入库<br/>异常、停机、打卡</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">4</div>
                <div class="n-name">仓储与交付</div>
                <div class="n-desc">领料、入库、盘点<br/>采购到货<br/>发货出库</div>
              </div>
              <div class="arrow">→</div>
              <div class="node primary">
                <div class="n-step">5</div>
                <div class="n-name">设备维保</div>
                <div class="n-desc">维保计划生成工单<br/>开工 / 完成 / 取消<br/>源成本只做分类</div>
              </div>
            </div>
          </section>

          <section class="flow-block">
            <div class="flow-title">二、PC 与车间 App</div>
            <div class="roles">
              <div class="role-card">
                <div class="role-head pc">PC 管理端</div>
                <ul>
                  <li>主数据、组织、角色菜单</li>
                  <li>工单、排程、进度大屏、报工确认</li>
                  <li>库存单据审核、发货、采购到货</li>
                  <li>维保计划与维保工单</li>
                </ul>
              </div>
              <div class="role-card">
                <div class="role-head app">车间 App</div>
                <ul>
                  <li>绑定员工后看已开工工序</li>
                  <li>扫码报工：先存草稿，再确认扣料</li>
                  <li>停机登记、报修（生成维修工单）</li>
                  <li>当前仓库的草稿领料、查库存、盘点</li>
                </ul>
              </div>
            </div>
            <div class="role-flow">
              <span class="chip pc">PC 开工单并开工工序</span>
              <span class="arr">→</span>
              <span class="chip app">App 报工确认</span>
              <span class="arr">→</span>
              <span class="chip pc">库存与发货在 PC 核对</span>
            </div>
          </section>

          <section class="flow-block">
            <div class="flow-title">三、几条日常细流</div>
            <div class="sub-flows">
              <div class="sub-flow">
                <div class="sub-label">报工</div>
                <div class="sub-steps">
                  <span>工序开工</span>
                  <i>→</i>
                  <span>保存报工草稿</span>
                  <i>→</i>
                  <span>确认（选仓 / 批次 / 替代料）</span>
                  <i>→</i>
                  <span>自动领料与入库</span>
                </div>
              </div>
              <div class="sub-flow">
                <div class="sub-label">领料</div>
                <div class="sub-steps">
                  <span>PC 或扫码生成草稿</span>
                  <i>→</i>
                  <span>单头填写出库仓</span>
                  <i>→</i>
                  <span>App 改实发数量</span>
                  <i>→</i>
                  <span>保存并审核</span>
                </div>
              </div>
              <div class="sub-flow">
                <div class="sub-label">维保</div>
                <div class="sub-steps">
                  <span>维保计划</span>
                  <i>→</i>
                  <span>生成工单（计划）</span>
                  <i>→</i>
                  <span>开工（设备维修中）</span>
                  <i>→</i>
                  <span>完成或取消（设备恢复运行）</span>
                </div>
              </div>
            </div>
          </section>

          <section class="flow-block last">
            <div class="flow-title">四、车间人员怎么开始</div>
            <div class="flow-row compact">
              <div class="node soft">
                <div class="n-name">PC 维护员工</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">App 绑定员工</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">扫工单或打开已开工任务</div>
              </div>
              <div class="arrow">→</div>
              <div class="node soft">
                <div class="n-name">报工确认 / 停机 / 报修</div>
              </div>
            </div>
            <p class="hint">App 工序任务只列出已开工。待执行要先在 PC「工序任务」点开工。报工不强制打卡；当前计时只显示这一名员工是否有未结束的计时。</p>
          </section>
        </div>
      </el-tab-pane>
      <el-tab-pane label="操作手册" name="manual">
        <user-manual />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UserManual from './UserManual.vue'

export default {
  name: 'HelpBizFlow',
  components: { UserManual },
  data() {
    return {
      tab: 'flow'
    }
  },
  created() {
    // 仅首次进入时读 query，切换页签不再改路由，避免 TagsView 按 fullPath 重复开页签
    const t = this.$route.query.tab
    if (t === 'manual' || t === 'flow') this.tab = t
  }
}
</script>

<style scoped>
.help-center {
  max-width: 1100px;
}
.help-center >>> .el-tabs__header {
  margin-bottom: 16px;
}
.biz-flow {
  max-width: 1100px;
}

.intro {
  margin-bottom: 20px;
}
.intro h2 {
  margin: 0 0 6px;
  font-size: 20px;
  color: #0f172a;
}
.intro p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.flow-block {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 20px 20px;
  margin-bottom: 16px;
}
.flow-block.last {
  margin-bottom: 0;
}
.flow-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 14px;
}

.flow-row {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 8px;
}
.flow-row.compact .node {
  min-width: 140px;
  flex: 1;
}

.node {
  flex: 1;
  min-width: 150px;
  border-radius: 10px;
  padding: 14px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.node.primary {
  background: linear-gradient(180deg, #eff6ff 0%, #f8fafc 100%);
  border-color: #bfdbfe;
}
.node.soft {
  background: #f1f5f9;
  text-align: center;
  padding: 16px 10px;
}
.n-step {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.n-name {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
  font-size: 14px;
}
.n-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}
.arrow {
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 18px;
  font-weight: 600;
  padding: 0 2px;
}

.roles {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.role-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fafbfc;
}
.role-head {
  padding: 10px 14px;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
}
.role-head.pc { background: #2563eb; }
.role-head.app { background: #0d9488; }
.role-head.mp { background: #7c3aed; }
.role-card ul {
  margin: 0;
  padding: 12px 14px 14px 30px;
  color: #475569;
  font-size: 13px;
  line-height: 1.7;
}
.role-flow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}
.chip {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
}
.chip.pc { background: #2563eb; }
.chip.app { background: #0d9488; }
.chip.mp { background: #7c3aed; }
.arr { color: #94a3b8; font-weight: 600; }

.sub-flows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sub-flow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.sub-label {
  flex: 0 0 52px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 6px;
  background: #0f172a;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.sub-steps {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}
.sub-steps span {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #334155;
}
.sub-steps i {
  font-style: normal;
  color: #94a3b8;
  font-weight: 600;
}

.hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: #94a3b8;
}

@media (max-width: 900px) {
  .roles { grid-template-columns: 1fr; }
  .arrow { display: none; }
  .node { min-width: 100%; }
}
</style>
